import { Box, Paper } from '@mui/material';
import { Trans } from 'react-i18next';

const StartPage = (): JSX.Element => {
  return (
    <Paper elevation={2} sx={{ px: 2, py: 2, width: '100%', display: 'flex', overflow: 'auto' }}>
      <Box>
        <h3 className='test1'>
          <Trans>Optische Messtechnik und Bildverarbeitung</Trans>
        </h3>
        <h1>
          <i>
            <Trans>Visionlab</Trans>
          </i>{' '}
          - <Trans>das virtuelle Bildverarbeitungslabor</Trans>
        </h1>
        <p>
          {/* TODO: use internationalization */}
          <Trans
            components={{ italic: <i />}}>
              Herzlich Willkommen in <i>Visionlab</i>, dem virtuellen Bildverarbeitungslabor im Rahmen der
              Masterveranstaltung <i>Optische Messtechnik und Bildverarbeitung</i>.
          </Trans>
        </p>
        <p>
          <Trans>
            IntroductionOne
          </Trans>
        </p>
        <p>
          {/* TODO: use internationalization */}
          <Trans
            components={{ italic: <i />}}>
              IntroductionTwo
          </Trans>
        </p>
        <p>
          <Trans>IntroductionThree</Trans>{' '}
          <a href="mailto:matthias.bodenbenner@wzl-iqs.rwth-aachen.de">Matthias Bodenbenner</a>.
        </p>
      </Box>
    </Paper>
  );
};

export default StartPage;
